<template>
  <div class="collection-panel">
    <AvailableCollectionDropdown
      class="collection-panel__dropdown"
      :product="product"
    />
    <p class="collection-panel__description">
      {{ $currentCollection.description[product.metal] }}
    </p>
  </div>
</template>
<script>
import AvailableCollectionDropdown from '@/components/layouts/products/blocks/AvailableCollectionsDropdown.vue';

export default {
  name: 'CollectionPanel',
  components: {
    AvailableCollectionDropdown,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="stylus" scoped>
.collection-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;

  +mobile() {
    margin-bottom: 30px;
  }
  &__dropdown {
    +mobile(){
      width: 100%;
    }
  }
  &__description {
    text-align: left;
    font-size: 16px;

    +mobile() {
      display: none;
      color: var(--inverted-text-color);
    }
  }
}
</style>
